module.exports = __webpack_public_path__ + "img/adminBanner.9b7db07b.png";